<template>
	<AppLayout :title="trans('statistics.title')">
		<div class="grid grid-cols-1 gap-4">
			<Card :title="transChoice('statistics.colleges.title', collegeCount)" :subtitle="trans('statistics.colleges.subtitle')">
				<DoughnutChart :chart-data="collegeData" :options="doughnutOptions"/>
			</Card>
			<Card :title="transChoice('statistics.students.title', studentCount)" :subtitle="trans('statistics.students.subtitle')">
				<DoughnutChart :chart-data="studentData" :options="doughnutOptions"/>
			</Card>
			<Card :title="transChoice('statistics.majors.title', majorCount)" :subtitle="trans('statistics.majors.subtitle')">
				<DoughnutChart :chart-data="majorData" :options="unlabeledOptions"/>
			</Card>
			<Card :title="transChoice('statistics.enrollments.title', enrolleeCount)" :subtitle="trans('statistics.enrollments.subtitle')">
				<BarChart :chart-data="barData" :options="barOptions"/>
			</Card>
			<Card :title="transChoice('statistics.registrations.title', registrationCount)" :subtitle="trans('statistics.registrations.subtitle')">
				<LineChart :chart-data="registrationData" :options="unlabeledOptions"/>
			</Card>
			<Card>
				<div class="grid grid-cols-2 gap-4">
					<ArgentinaData :total="userRegionCount" :data="regions"/>
					<table class="border-collapse">
						<thead>
							<tr class="border-b border-b-black dark:border-b-white">
								<th class="px-2 py-1 text-left">{{ trans('statistics.argentina.provinces') }}</th>
								<th class="px-2 py-1 text-left">{{ trans('statistics.argentina.students') }}</th>
							</tr>
						</thead>
						<tbody class="divide-y divide-gray-200 dark:divide-gray-800">
							<tr v-for="region in regions" class="hover:bg-gray-100 dark:hover:bg-gray-900">
								<td class="px-2 py-1 text-nowrap">{{ region.name }}</td>
								<td class="px-2 py-1">{{ region.users_count }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</Card>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {defineProps, ref} from 'vue'
import {type Region} from '@/Types/Region'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import {Chart, type ChartData, registerables} from 'chart.js'
import {BarChart, DoughnutChart, LineChart} from 'vue-chart-3'
import ArgentinaData from '@/Components/UI/Maps/Argentina/ArgentinaData.vue'

Chart.register(ChartDataLabels)
Chart.register(...registerables)
Chart.defaults.maintainAspectRatio = false
Chart.overrides['doughnut'].plugins.legend.display = true
Chart.overrides['doughnut'].plugins.legend.position = 'right'

defineProps<{
	userCount:number,
	majorCount:number,
	studentCount:number,
	collegeCount:number,
	enrolleeCount:number,
	userRegionCount:number,
	registrationCount:number,
	regions:Array<Region>,
	regionData:Array<number>,
	barData:ChartData<'bar',Array<number>,string>,
	majorData:ChartData<'doughnut',Array<number>,string>,
	studentData:ChartData<'doughnut',Array<number>,string>,
	collegeData:ChartData<'doughnut',Array<number>,string>,
	registrationData:ChartData<'line',Array<number>,string>,
}>()

const unlabeledOptions = ref({
	plugins: {
		datalabels: {
			display: false,
		},
	},
})

const doughnutOptions = ref({
	plugins: {
		datalabels: {
			color: 'white',
		},
	},
})

const barOptions = ref({
	plugins: {
		datalabels: {
			color: 'white',
			anchor: 'end',
			clamp: true,
			align: 'bottom',
		},
	},
})
</script>